import { Card } from 'antd';
import React from 'react';

const PaypalData = ({ t, payment }) =>
    <Card className="gx-card" title={t('pay_with_' + payment.active)} >
        {t('paypal_payment_description')}
    </Card>;

export default PaypalData;